import { supabase } from './supabase'

const rawApiUrl = import.meta.env.VITE_LOGMANE_API_URL as string | undefined
const internalApiUrl = rawApiUrl?.replace(/\/+$/, '') ?? ''

export function hasInternalApi(): boolean {
  return internalApiUrl.length > 0
}

export async function internalApiGet<T>(path: string): Promise<T> {
  return internalApiRequest<T>(path, { method: 'GET' })
}

export async function internalApiPost<T>(path: string, body: unknown): Promise<T> {
  return internalApiRequest<T>(path, {
    method: 'POST',
    body: JSON.stringify(body)
  })
}

export async function internalApiPatch<T>(path: string, body: unknown): Promise<T> {
  return internalApiRequest<T>(path, {
    method: 'PATCH',
    body: JSON.stringify(body)
  })
}

export async function internalApiDelete<T>(path: string): Promise<T> {
  return internalApiRequest<T>(path, { method: 'DELETE' })
}

async function internalApiRequest<T>(
  path: string,
  init: RequestInit
): Promise<T> {
  if (!internalApiUrl) {
    throw new Error('VITE_LOGMANE_API_URL is not configured')
  }

  const { data } = await supabase.auth.getSession()
  const token = data.session?.access_token
  if (!token) throw new Error('Not signed in')

  const response = await fetch(`${internalApiUrl}${path}`, {
    ...init,
    headers: {
      'content-type': 'application/json',
      authorization: `Bearer ${token}`,
      ...(init.headers ?? {})
    }
  })

  const payload = await response.json().catch(() => null)
  if (!response.ok) {
    const message =
      typeof payload?.error?.message === 'string'
        ? payload.error.message
        : `Internal API request failed: ${response.status}`
    throw new Error(message)
  }

  return payload as T
}
